import { alpha, type Theme, type ThemeOptions } from '@mui/material/styles';

const OUTER_PX = 45;
const BORDER_PX = 2.5;
const INNER_DOT_PX = 14;

/** Pending step ring: #1E2A3A at ~20% opacity (matches `#1E2A3A33`). */
const PENDING_BORDER = alpha('#1E2A3A', 0.2);

const STEP_LABEL_COLOR = '#627083';

export function stepperThemeComponents(theme: Theme): ThemeOptions['components'] {
  const orange = theme.palette.warning.main;

  return {
    MuiStepper: {
      styleOverrides: {
        root: {
          '&.SmStepper-root': {
            padding: theme.spacing(2, 0),
            backgroundColor: 'transparent',
            '& .SmStepIcon-root': {
              width: OUTER_PX,
              height: OUTER_PX,
              boxSizing: 'border-box',
              borderRadius: '50%',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            },
            '& .SmStepIcon-completed': {
              backgroundColor: orange,
              border: `${BORDER_PX}px solid transparent`,
              color: theme.palette.common.white,
              '& .SmStepIcon-check': {
                fontSize: 20,
                width: 20,
                height: 20
              }
            },
            '& .SmStepIcon-active': {
              border: `${BORDER_PX}px solid ${orange}`,
              backgroundColor: 'transparent',
              color: orange
            },
            '& .SmStepIcon-innerDot': {
              display: 'block',
              width: INNER_DOT_PX,
              height: INNER_DOT_PX,
              borderRadius: '50%',
              backgroundColor: orange
            },
            '& .SmStepIcon-pending': {
              border: `${BORDER_PX}px solid ${PENDING_BORDER}`,
              backgroundColor: 'transparent'
            }
          }
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: STEP_LABEL_COLOR,
          '&.Mui-active': {
            fontWeight: 400,
            color: STEP_LABEL_COLOR
          },
          '&.Mui-completed': {
            color: STEP_LABEL_COLOR
          }
        },
        labelContainer: {
          '& .MuiStepLabel-label': {
            marginTop: theme.spacing(1)
          }
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderTopWidth: 1,
          borderColor: theme.palette.divider
        },
        alternativeLabel: {
          top: OUTER_PX / 2
        }
      }
    }
  };
}
